import React from "react";
import { Scale, AlertTriangle } from "lucide-react";
import { Badge } from "./ui/badge";

const ComparisonSection = () => {
  return (
    <section
      id="comparison"
      className="py-24 sm:py-32 bg-gradient-to-b from-white via-slate-50 to-white"
      data-testid="comparison-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-emerald-600 font-semibold mb-4">
            <Scale className="w-4 h-4" />
            The Truth About Investing
          </span>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-semibold leading-snug text-emerald-950 mb-4">
            Separate Myth from Reality
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Don't let common misconceptions hold you back from building wealth.
          </p>
        </div>

        {/* Myth vs Reality */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-testid="myth-reality">
          <div className="bg-rose-50 border border-rose-200 rounded-2xl p-6">
            <Badge className="bg-rose-500 text-white mb-4">MYTH</Badge>
            <p className="text-lg font-semibold text-rose-900 mb-2">
              "I need to time the market to make money."
            </p>
            <p className="text-rose-700">
              Many investors wait for the "perfect entry point" and miss years of compounding 
              while the market moves without them.
            </p>
          </div>
          <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-6">
            <Badge className="bg-emerald-500 text-white mb-4">REALITY</Badge>
            <p className="text-lg font-semibold text-emerald-900 mb-2">
              "The best time to invest was yesterday; the second best time is today."
            </p>
            <p className="text-emerald-700">
              <strong>Rupee Cost Averaging (SIP)</strong> handles the volatility for you. 
              You buy more units when prices are low and fewer when high – automatically!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
